import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import * as dayjs from 'dayjs';
import { DispoService } from '../../services/dispos/dispo.service';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
	selector: 'app-dispo-reports',
	templateUrl: './dispo-reports.component.html',
	styleUrls: ['./dispo-reports.component.scss']
})
export class DispoReportsComponent implements OnInit {

	@ViewChild(DatatableComponent) table: DatatableComponent;

	temp = [];
	data = [];
	ColumnMode = ColumnMode;
	dateRange_;
	fromDate: string = '';
	toDate: string = '';
	selectedTab = 'all';
	loading = false;
	selectedDispo = '';
	recordsPerPage = 10;

	// CHARTS

	chartStructure: any;
	xAxisSelected: string; // Month, Day, Year, Week
	// Observable for update
	update$: Subject<any> = new Subject();



	constructor(private DispoSrv: DispoService, private modalSrv: NgbModal) {
		this.xAxisSelected = 'day';
		this.fromDate = dayjs().subtract(1, 'month').format('YYYY-MM-DD') + ' 00:00:00';
		this.toDate = dayjs().format('YYYY-MM-DD') + ' 23:59:59';

		this.dateRange_ = {
			dateStart: dayjs().subtract(1, 'month'),
			dateEnd: dayjs()
		};

		this.chartStructure = {
			chart: {
				height: 380,
				type: 'line',
				zoom: {
					enabled: false,
				},
				toolbar: {
					show: false,
				},
			},
			colors: ["#50E7A6", "#3F475D", "#40A0FC", "#FEBC4A"],
			dataLabels: {
				enabled: false,
			},
			stroke: {
				width: [3, 3],
				curve: 'straight',
			},
			series: [
				{
					name: 'Green Dispo',
					data: [26, 24, 32, 36, 33, 31, 33],
				},
				{
					name: 'Black Dispos',
					data: [14, 40, 23, 32, 17, 13, 18],
				},
				{
					name: 'Blue Dispos',
					data: [14, 11, 16, 22, 17, 13, 45],
				},
				{
					name: 'Yellow Dispos',
					data: [14, 17, 16, 15, 17, 19, 12],
				},
			],
			title: {
				text: 'Dispos in Time',
				align: 'left',
				style: {
					fontWeight: 500,
				},
			},
			grid: {
				row: {
					colors: ['transparent', 'transparent'],
					opacity: 0.2,
				},
				borderColor: '#f1f1f1',
			},
			markers: {
				size: 6,
			},
			xaxis: {
				categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
				title: {
					text: 'Month',
				},
			},
			yaxis: {
				title: {
					text: 'Dispos',
				},
				min: 0,
				max: 100,
			},
			legend: {
				position: 'top',
				horizontalAlign: 'right',
				floating: true,
				offsetY: -25,
				offsetX: -5,
			},
		};
	}

	ngOnInit() {
		this.getDispos();
	}

	updateFilter2(event, props: string) {
		const val = event.target.value.toLowerCase();
		const propArray = props.split(',');
		// filter our data
		const temp = this.temp.filter(function (d) {
			return propArray.some(prop => {
				if(d[prop] != null ){
					return d[prop].toLowerCase().indexOf(val) !== -1 || !val;
				}
			});
		});

		// update the rows
		this.data = temp;
		// Whenever the filter changes, always go back to the first page
		this.table.offset = 0;
	}

	dateSelected(dates: any) {
		this.fromDate = dayjs(dates.dateStart).format('YYYY-MM-DD') + ' 00:00:00';
		this.toDate = dayjs(dates.dateEnd).format('YYYY-MM-DD') + ' 23:59:59';

	}

	getDispos(dispoType = 'all'){
		this.loading = true;
		const black = ['FAX','BUSY','DISCO','NOTINT','WRONG','DONOTCALL','NOMARKET'];
		const yellow = ['HOT','FYI','SINFO'];
		const blue = ['NOMSG','MSG','NOANS','TREE','GKINFO'];
		const green = ['FACE','PHONE','ZOOM','FIX'];
		this.DispoSrv.getDisposReport(this.fromDate, this.toDate, dispoType).subscribe((data: any)=>{
			data.body.map(dispo=>{
				if(black.includes(dispo.dispo)){
					dispo.color = 'black';
				} else if (yellow.includes(dispo.dispo)){
					dispo.color = 'yellow';
				} else if (blue.includes(dispo.dispo)){
					dispo.color = 'blue';
				} else if (green.includes(dispo.dispo)){
					dispo.color = 'green';
				}
			})
			this.loading = false;
			this.data = data.body;
			this.temp = [...this.data];
			this.buildChart();
		});
	}

	onTabClick(tab: string){
		this.selectedTab = tab;
		switch (tab) {
			case 'black':
				this.getDispos("'FAX','BUSY','DISCO','NOTINT','WRONG','DONOTCALL','NOMARKET'");
				break;

			case 'yellow':
				this.getDispos("'HOT','FYI','SINFO'");
				break;

			case 'blue':
				this.getDispos("'NOMSG','MSG','NOANS','TREE','GKINFO'");
				break;

			case 'green':
				this.getDispos("'FACE','PHONE','ZOOM','FIX'");
				break;
			default:
				this.getDispos();
				break;
		}
	}

	getBadgeColor(dispo: string): string{
		const black = ['FAX','BUSY','DISCO','NOTINT','WRONG','DONOTCALL','NOMARKET'];
		const yellow = ['HOT','FYI','SINFO'];
		const blue = ['NOMSG','MSG','NOANS','TREE','GKINFO'];
		const green = ['FACE','PHONE','ZOOM','FIX'];

		if(black.includes(dispo)){
			return 'bg-dark';
		} else if(yellow.includes(dispo)){
			return 'bg-warning';
		} else if(blue.includes(dispo)){
			return 'bg-primary';
		} else if(green.includes(dispo)){
			return 'bg-success';
		}
	}

	buildChart(){
		if(this.xAxisSelected === 'month'){
			this.chartStructure.xaxis.categories = this.getMonthsInRange(this.fromDate, this.toDate);
		} else if (this.xAxisSelected === 'day') {
			this.chartStructure.xaxis.categories = this.getAllDaysInRange(this.fromDate, this.toDate);
			this.buildChartData();
			this.updateChart();
		}
	}

	buildChartData(){
		let blackDispos = [];
		let yellowDispos = [];
		let blueDispos = [];
		let greenDispos = [];

		blackDispos = this.data.filter(dispo=>{
			return dispo.color === 'black';
		});

		yellowDispos = this.data.filter(dispo=>{
			return dispo.color === 'yellow';
		});

		blueDispos = this.data.filter(dispo=>{
			return dispo.color === 'blue';
		});

		greenDispos = this.data.filter(dispo=>{
			return dispo.color === 'green';
		});

		if(this.selectedTab === 'all'){
			this.chartStructure.series[0].data = this.countDailyRecords(greenDispos);
			this.chartStructure.series[1].data = this.countDailyRecords(blackDispos);
			this.chartStructure.series[2].data = this.countDailyRecords(blueDispos);
			this.chartStructure.series[3].data = this.countDailyRecords(yellowDispos);
			this.chartStructure.yaxis.max = 100;
		} else if (this.selectedTab === 'black'){
			this.chartStructure.series[0].data = [];
			this.chartStructure.series[1].data = this.countDailyRecords(blackDispos);
			this.chartStructure.series[2].data = [];
			this.chartStructure.series[3].data = [];

			this.chartStructure.yaxis.max = Math.max(...this.chartStructure.series[1].data);
		} else if (this.selectedTab === 'green'){
			this.chartStructure.series[0].data = this.countDailyRecords(greenDispos);
			this.chartStructure.series[1].data = [];
			this.chartStructure.series[2].data = [];
			this.chartStructure.series[3].data = [];

			this.chartStructure.yaxis.max = Math.max(...this.chartStructure.series[0].data);
		} else if (this.selectedTab === 'yellow'){
			this.chartStructure.series[0].data = [];
			this.chartStructure.series[1].data = [];
			this.chartStructure.series[2].data = [];
			this.chartStructure.series[3].data = this.countDailyRecords(yellowDispos);
			this.chartStructure.yaxis.max = Math.max(...this.chartStructure.series[3].data);
		} else if (this.selectedTab === 'blue'){
			this.chartStructure.series[0].data = [];
			this.chartStructure.series[1].data = [];
			this.chartStructure.series[2].data = this.countDailyRecords(blueDispos);
			this.chartStructure.series[3].data = [];
			this.chartStructure.yaxis.max = Math.max(...this.chartStructure.series[2].data);
		}
	}

	getMonthsInRange(fromDate, toDate) {
		const start = dayjs(fromDate);
		const end = dayjs(toDate);

		const months = [];

		let current = start;
		while (current.isBefore(end) || current.isSame(end, 'day')) {
			months.push(current.format('MMM'));
			current = current.add(1, 'month');
		}

		return months;
	}

	getAllDaysInRange(fromDate, toDate) {
		const start = dayjs(fromDate);
		const end = dayjs(toDate);

		const days = [];
		let current = start;

		while (current.isBefore(end) || current.isSame(end, 'day')) {
			days.push(current.format('D MMM'));
			current = current.add(1, 'day');
		}

		return days;
	}

	// Update function
	updateChart(){
		this.update$.next(true);
	}

	// countDailyRecords(data) {
	// 	// Crear un objeto para almacenar los conteos diarios
	// 	const dailyCounts = {};

	// 	// Iterar sobre cada objeto en el array
	// 	data.forEach(obj => {
	// 		// Obtener la fecha en formato 'YYYY-MM-DD'
	// 		const date = obj.date.split(' ')[0];

	// 		// Incrementar el conteo para la fecha correspondiente
	// 		if (dailyCounts[date]) {
	// 			dailyCounts[date]++;
	// 		} else {
	// 			dailyCounts[date] = 1;
	// 		}
	// 	});

	// 	// Crear un array de objetos con fecha y conteo
	// 	const result = [];
	// 	const start = dayjs(Object.keys(dailyCounts)[0]);
	// 	const end = dayjs(Object.keys(dailyCounts)[Object.keys(dailyCounts).length - 1]);

	// 	let current = start;
	// 	while (current.isBefore(end) || current.isSame(end, 'day')) {
	// 		const date = current.format('YYYY-MM-DD');
	// 		const count = dailyCounts[date] || 0;
	// 		result.push({date, count});
	// 		current = current.add(1, 'day');
	// 	}

	// 	return result;
	// }

	countDailyRecords(data) {
		// Crear un objeto para almacenar los conteos diarios
		const dailyCounts = {};

		// Iterar sobre cada objeto en el array
		data.forEach(obj => {
			// Obtener la fecha en formato 'YYYY-MM-DD'
			const date = obj.date.split(' ')[0];

			// Incrementar el conteo para la fecha correspondiente
			if (dailyCounts[date]) {
				dailyCounts[date]++;
			} else {
				dailyCounts[date] = 1;
			}
		});

		// Crear un array de objetos con fecha y conteo
		const result = [];
		const start = dayjs(this.fromDate);
		const end = dayjs(this.toDate);

		let current = start;
		while (current.isBefore(end) || current.isSame(end, 'day')) {
			const date = current.format('YYYY-MM-DD');
			const count = dailyCounts[date] || 0;
			result.push(count);
			current = current.add(1, 'day');
		}

		return result;
	}

	getDispoDetails(dispo_id, modal: TemplateRef<any>){
		this.DispoSrv.getDispoDetails(dispo_id).subscribe((data: any)=>{
			this.selectedDispo = data.body;
			this.modalSrv.open(modal, { size: 'xl', centered: true });
		});
	}

	public onRecordsPerPageChange(): void {
		this.changePageLimit(this.recordsPerPage);
		this.table.limit = this.recordsPerPage;
		this.table.recalculate();
		setTimeout(() => {
		  if (this.table.bodyComponent.temp.length <= 0) {
			// TODO[Dmitry Teplov] find a better way.
			// TODO[Dmitry Teplov] test with server-side paging.
			this.table.offset = Math.floor((this.table.rowCount - 1) / this.table.limit);
			// this.table.offset = 0;
		  }
		});
	  }

	  private changePageLimit(limit: any): void {
		this.recordsPerPage = parseInt(limit, 10);
	  }
}
